import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { TranslatePipe } from '@ngx-translate/core';
import { BaaRequestFlowService } from '../baa-request-flow.service';
import { BaaRequestListItemsComponent } from '../baa-request-list-items/baa-request-list-items.component';

@Component({
  selector: 'lib-baa-request-decision',
  imports: [SvgIconComponent, TranslatePipe, BaaRequestListItemsComponent],
  templateUrl: './baa-request-decision.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaRequestDecisionComponent {
  protected readonly service = inject(BaaRequestFlowService);
}
